import { useId } from "react";
import type { CSSProperties } from "react";

import GoogleLoginButton from "../../../components/buttons/GoogleLoginButton";
import { OnflyLogo } from "../../../components/OnflyLogo";
import { RoutesScene } from "./RoutesScene";
import "../LoginScreen.css";

interface UserTypeSelectorProps {
  onCollaboratorLogin: () => void;
  onCandidateClick: () => void;
  googleError?: string | null;
  dark?: boolean;
  accent?: string;
  title?: string;
  subtitle?: string;
}

const UserTypeSelector = ({
  onCollaboratorLogin,
  onCandidateClick,
  googleError = null,
  dark = false,
  accent = "#009EFB",
  title = "Bem-vindo ao GG Hub",
  subtitle = "Acesse a plataforma utilizando sua conta corporativa Onfly.",
}: UserTypeSelectorProps) => {
  const titleId = useId();
  
  return (
    <div
      className={`gg-login ${dark ? "is-dark" : ""}`}
      style={{ "--gg-accent": accent } as CSSProperties}
    >
      <div className="gg-scene-wrap" aria-hidden>
        <RoutesScene accent={accent} />
      </div>

      <main className="gg-card-wrap">
        <section className="gg-card" role="region" aria-labelledby={titleId}>
          <div className="gg-stack">
            <div className="gg-brand-row anim-step" style={{ "--i": 0 } as CSSProperties}>
              <OnflyLogo dark={dark} height={44} />
            </div>

            <h1 id={titleId} className="gg-title anim-step" style={{ "--i": 2 } as CSSProperties}>
              {title}
            </h1>

            <p className="gg-subtitle anim-step" style={{ "--i": 3 } as CSSProperties}>
              {subtitle}
            </p>

            <GoogleLoginButton
              className="anim-step"
              style={{ "--i": 6 } as CSSProperties}
              label="Entrar com conta Onfly"
              onClick={onCollaboratorLogin}
            />

            {googleError && (
              <div
                role="alert"
                className="anim-step"
                style={{
                  "--i": 6,
                  marginTop: 8,
                  padding: "10px 12px",
                  borderRadius: 8,
                  background: "rgba(220, 38, 38, 0.08)",
                  border: "1px solid rgba(220, 38, 38, 0.35)",
                  color: "#dc2626",
                  fontSize: 13,
                  lineHeight: 1.4,
                  textAlign: "center",
                } as CSSProperties}
              >
                {googleError}
              </div>
            )}
          </div>
        </section>
      </main>
    </div>
  );
};

export default UserTypeSelector;
